import { KeyValEntityType as BPCR_KeyValEntityType, APP_NAME as BPCR_APP_NAME } from '@/agents/blog-post-content-refresher/constants';
import { KeyValEntityType as BPCS_KeyValEntityType, APP_NAME as BPCS_APP_NAME } from '@/agents/blog-post-content-strategizer/constants';

export interface BucketConfig {
  todoBucket: string;
  inProgressBucket: string;
  waitingForApprovalBucket?: string; // OPTIONAL for 4-bucket agents
  completedBucket: string;
  failedBucket: string;
  appName: string;
}

const BUCKET_REGISTRY: Record<string, BucketConfig> = {
  'blog-post-content-refresher': {
    todoBucket: BPCR_KeyValEntityType.TASKS_TODO_BUCKET,
    inProgressBucket: BPCR_KeyValEntityType.TASKS_IN_PROGRESS_BUCKET,
    waitingForApprovalBucket: BPCR_KeyValEntityType.TASKS_WAITING_FOR_APPROVAL_BUCKET,
    completedBucket: BPCR_KeyValEntityType.TASKS_COMPLETED_BUCKET,
    failedBucket: BPCR_KeyValEntityType.TASKS_FAILED_BUCKET,
    appName: BPCR_APP_NAME,
  },
  'blog-post-content-strategizer': {
    todoBucket: BPCS_KeyValEntityType.TASKS_TODO_BUCKET,
    inProgressBucket: BPCS_KeyValEntityType.TASKS_IN_PROGRESS_BUCKET,
    // NO waitingForApprovalBucket (4-bucket pattern)
    completedBucket: BPCS_KeyValEntityType.TASKS_COMPLETED_BUCKET,
    failedBucket: BPCS_KeyValEntityType.TASKS_FAILED_BUCKET,
    appName: BPCS_APP_NAME,
  },
};

export function getBucketConfig(agentShortName: string): BucketConfig | undefined {
  return BUCKET_REGISTRY[agentShortName];
}
